import { Drawer } from 'antd';
import ScheduleDetailComponent from '../../components/schedules/ScheduleDetailComponent';
import ScheduleEditDrawer from './ScheduleEditDrawer';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import {
  ScheduleListType,
  getScheduleDetailAsync,
  getScheduleListAsync,
  updateScheduleIndexAsync,
} from '../../modules/schedules';
import ScheduleBulkCreateModal from '../../components/schedules/ScheduleBulkCreateModal';
import {
  bulkCreateSchedule,
  getScheduleList,
  updateScheduleDepends,
} from '../../api/constlink';
import DependScheduleAddModal from '../../components/schedules/DependScheduleAddModal';

interface ScheduleDetailDrawerProps {
  enterpriseId: string;
  projectId: string;
  scheduleId?: string;
  visible: boolean;
  onClose: () => void;
}

function ScheduleDetailDrawer({
  enterpriseId,
  projectId,
  scheduleId,
  visible,
  onClose,
}: ScheduleDetailDrawerProps) {
  const [visibleEditDrawer, setVisibleEditDrawer] = useState<boolean>(false);
  const [openCreateModal, setOpenCreateModal] = useState<boolean>(false);
  const [openDependAddModal, setOpenDependAddModal] = useState<boolean>(false);
  const [scheduleList, setScheduleList] = useState<any[]>();

  const onCloseEditDrawer = () => {
    setVisibleEditDrawer(false);
  };
  const schedule = useSelector(
    (state: RootState) => state.schedules.schedule.data,
  );

  // const schedules = useSelector(
  //   (state: RootState) => state.schedules.schedules.data,
  // );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getScheduleDetailAsync.request({
        enterpriseId: enterpriseId,
        projectId: projectId,
        scheduleId: scheduleId,
      }),
    );
  }, [enterpriseId, projectId, scheduleId, dispatch]);

  useEffect(() => {
    if (!openDependAddModal) return;
    (async () => {
      const schedules: any = await getScheduleList({
        enterpriseId,
        projectId,
        type: ScheduleListType.FORM_LIST,
      });
      setScheduleList(schedules);
    })();
  }, [enterpriseId, projectId, openDependAddModal]);

  const moveToEditPage = () => {
    setVisibleEditDrawer(true);
  };

  const onCreateBulk = async (data: any) => {
    await bulkCreateSchedule({
      enterpriseId,
      projectId,
      scheduleId: scheduleId,
      nameList: data.list,
    });
    dispatch(
      getScheduleDetailAsync.request({
        enterpriseId: enterpriseId,
        projectId: projectId,
        scheduleId: scheduleId,
      }),
    );
    setTimeout(() => {
      dispatch(
        getScheduleListAsync.request({
          enterpriseId,
          projectId,
          type: ScheduleListType.TREE_LIST,
        }),
      );
    }, 1000);
    setOpenCreateModal(false);
  };

  const onCloseModal = () => {
    setOpenCreateModal(false);
  };

  const _updateScheduleIndex = async (
    scheduleId: string,
    scheduleIndex: number,
  ) => {
    const schedule = { index: scheduleIndex };
    dispatch(
      updateScheduleIndexAsync.request({
        enterpriseId,
        projectId,
        scheduleId,
        schedule,
      }),
    );
    /**
     * setTimeout: update schedule list
     */
    setTimeout(() => {
      dispatch(
        getScheduleListAsync.request({
          enterpriseId,
          projectId,
          type: ScheduleListType.TREE_LIST,
        }),
      );
    }, 1000);
  };

  return (
    <>
      <Drawer
        width={800}
        placement="right"
        closable={false}
        // closable={true}
        maskClosable={true}
        onClose={onClose}
        open={visible}
        // title={
        //   '공정 상세'
        //   // <Row>
        //   //   <Col>
        //   //     <Title level={3}>공정계획 상세</Title>
        //   //   </Col>
        //   //   <Col>
        //   //     <Space>
        //   //       <Button
        //   //         onClick={() => console.log('up')}
        //   //         icon={<UpOutlined rev={undefined} />}
        //   //         size="small"
        //   //       ></Button>
        //   //       <Button
        //   //         onClick={() => console.log('up')}
        //   //         icon={<DownOutlined rev={undefined} />}
        //   //         size="small"
        //   //       ></Button>
        //   //     </Space>
        //   //   </Col>
        //   // </Row>
        //   // <Space align="baseline" size={'middle'}>
        //   //   <Title level={3}>공정 상세</Title>
        //   //   <Button
        //   //     onClick={() => {
        //   //       console.log('up');
        //   //       if (!scheduleId || schedules === null || schedule === null)
        //   //         return;
        //   //       const index = schedules?.findIndex((s) => s.id === schedule.id);
        //   //       console.log(index);
        //   //       if (index === undefined || index === 0) return;
        //   //       const prevScheduleId = schedules[index - 1].id + '';
        //   //       dispatch(
        //   //         getScheduleDetailAsync.request({
        //   //           enterpriseId: enterpriseId,
        //   //           projectId: projectId,
        //   //           scheduleId: prevScheduleId,
        //   //         }),
        //   //       );
        //   //     }}
        //   //     icon={<UpOutlined rev={undefined} />}
        //   //     size="small"
        //   //   ></Button>
        //   //   <Button
        //   //     onClick={() => console.log('down')}
        //   //     icon={<DownOutlined rev={undefined} />}
        //   //     size="small"
        //   //   ></Button>
        //   // </Space>
        // }
        // extra={
        //   // <Button
        //   //   size="small"
        //   //   // onClick={() => moveToEditPage('' + schedule.id)}
        //   // >
        //   //   수정
        //   // </Button>

        //   <Space align="baseline">
        //     <Button
        //       onClick={() => {
        //         console.log('up');
        //         if (!scheduleId || schedules === null || schedule === null)
        //           return;
        //         const index = schedules?.findIndex((s) => s.id === schedule.id);
        //         console.log(index);
        //         if (index === undefined || index === 0) return;
        //         const prevScheduleId = schedules[index - 1].id + '';
        //         dispatch(
        //           getScheduleDetailAsync.request({
        //             enterpriseId: enterpriseId,
        //             projectId: projectId,
        //             scheduleId: prevScheduleId,
        //           }),
        //         );
        //       }}
        //       icon={<UpOutlined rev={undefined} />}
        //       size="small"
        //     ></Button>
        //     <Button
        //       onClick={() => console.log('down')}
        //       icon={<DownOutlined rev={undefined} />}
        //       size="small"
        //     ></Button>
        //     <Button
        //       size="small"
        //       // onClick={() => moveToEditPage('' + schedule.id)}
        //     >
        //       수정
        //     </Button>
        //   </Space>
        // }
      >
        {visible && schedule && (
          <ScheduleDetailComponent
            schedule={schedule}
            moveToEditPage={moveToEditPage}
            openSubScheduleCreateModal={() => {
              setOpenCreateModal(true);
            }}
            onDeleteSubSchedule={() => {
              console.log('onDeleteSubSchedule');
            }}
            updateScheduleIndex={_updateScheduleIndex}
            openDependAddModal={() => {
              setOpenDependAddModal(true);
            }}
          />
        )}
        {openCreateModal && (
          <ScheduleBulkCreateModal
            onCreate={onCreateBulk}
            onCancel={onCloseModal}
            visible={openCreateModal}
          />
        )}
        {openDependAddModal && schedule && scheduleList && (
          <DependScheduleAddModal
            visible={openDependAddModal}
            schedule={schedule}
            scheduleList={scheduleList}
            onCancel={() => setOpenDependAddModal(false)}
            onCreate={async (data) => {
              await updateScheduleDepends({
                enterpriseId,
                projectId,
                scheduleId,
                schedule: {
                  depends: data.depends.map((depend: any) => depend.value),
                },
              });
              dispatch(
                getScheduleDetailAsync.request({
                  enterpriseId: enterpriseId,
                  projectId: projectId,
                  scheduleId,
                }),
              );
              setOpenDependAddModal(false);
            }}
          />
        )}
      </Drawer>
      <ScheduleEditDrawer
        enterpriseId={enterpriseId}
        projectId={projectId}
        visible={visibleEditDrawer}
        onClose={onCloseEditDrawer}
      />
    </>
  );
}

export default ScheduleDetailDrawer;
